<nav [attr.aria-label]="'Pagination navigation'" [attr.data-testid]="testId()">
  <ul class="pagination">
    <!-- Previous Button -->
    <li class="page-item" [class.disabled]="!canGoPrevious()">
      <button
        class="page-link"
        (click)="previousPage()"
        [disabled]="!canGoPrevious()"
        aria-label="Go to previous page"
        type="button"
      >
        <i class="icon-chevron-left"></i>

        @if (showNavigationText()) {
          <span class="d-none d-md-inline ml-1">Précédent</span>
        }
      </button>
    </li>

    <!-- Page Counter (alternative to page numbers) -->
    @if (showCounter() && !showPageNumbers()) {
      <li class="page-item disabled">
        <span class="page-link counter">{{ counterText() }}</span>
      </li>
    }

    <!-- Page Numbers -->
    @if (showPageNumbers()) {
      @for (page of paginationRange(); track $index) {
        @if (!isEllipsis(page)) {
          <li class="page-item" [class.active]="isCurrentPage(page)">
            <button
              class="page-link"
              (click)="goToPage(page)"
              [attr.aria-current]="isCurrentPage(page) ? 'page' : null"
              type="button"
            >
              {{ page }}
            </button>
          </li>
        } @else {
          <li class="page-item disabled">
            <span class="page-link">{{ page }}</span>
          </li>
        }
      }
    }

    <!-- Page Counter (after page numbers) -->
    @if (showCounter() && showPageNumbers()) {
      <li class="page-item disabled">
        <span class="page-link counter">{{ counterText() }}</span>
      </li>
    }

    <!-- Next Button -->
    <li class="page-item" [class.disabled]="!canGoNext()">
      <button
        class="page-link"
        (click)="nextPage()"
        [disabled]="!canGoNext()"
        aria-label="Go to next page"
        type="button"
      >
        @if (showNavigationText()) {
          <span class="d-none d-md-inline mr-1">Suivant</span>
        }

        <i class="icon-chevron-right"></i>
      </button>
    </li>
  </ul>
</nav>
